import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const dashboardState = (state: RootState) => state.scene.dashboard;

export const isLoading = createSelector(dashboardState, ({ loading }) => loading);
export const getScope = createSelector(dashboardState, ({ scope }) => scope);
export const getEventsFilters = createSelector(
  dashboardState,
  ({ eventsFilters }) => eventsFilters
);
export const getBoards = createSelector(dashboardState, ({ boards }) => boards);
export const areBoardsFetched = createSelector(
  dashboardState,
  ({ boardsFetched }) => boardsFetched
);
export const getEvents = createSelector(dashboardState, ({ events }) => events);
export const getEventsTotal = createSelector(dashboardState, ({ eventsTotal }) => eventsTotal);
export const getHasMoreEvents = createSelector(
  dashboardState,
  ({ hasMoreEvents }) => hasMoreEvents
);
export const getOldestEventDate = createSelector(
  dashboardState,
  ({ oldestEventDate }) => oldestEventDate
);

// Other selectors
export * from "./coaching/categories/selectors";
export * from "./coaching/files/selectors";
export * from "./coaching/notes/selectors";
export * from "./coaching/noteWithTask/selectors";
export * from "./coaching/tasks/selectors";
export * from "./stackRank/selectors";
